
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';


import { Injectable } from '@angular/core';
import { LcpHelper } from '../_helpers/lcp-helper';
// import { Router } from '@angular/router';


@Injectable()
export class TypableService {

  constructor(
    private lcpHelper: LcpHelper
  ) {}


  initIntersectionObserver(el: any, params={}) {
    // console.log('TODO: el', el)
    const observer = new IntersectionObserver( 
      ([e]) => {
        // if (this.mobileTypedServiceIndices.includes(i)) return 
        if (el.classList.contains('is-typed')) return // console.log('CHECK is-typed', el)
        if (e.intersectionRatio < 0.05) return
        el.classList.add('is-typed')
        // console.log('TODO: type mobile', i, e.target)
        const typableTextElement = this.typableTextElementWithinContainer(e.target)

        // console.log('TODO: type mobile', i, this.fields)
        this.typeTextNow(typableTextElement, params)
      },

      // ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), 
      { rootMargin: '300px 0px -200px 0px',
        threshold: this.lcpHelper.percentageSequence(500) }
    );

    // console.log('scroll-inter', el)
    observer.observe(el)
    return observer
  }

  typableTextElementWithinContainer(el: Element) {
    return el.querySelector('.typable-text')
    // console.log('CHECK typableTextElementWithinContainer', el)
    // return el.querySelector('.typable-container')
  }


  typeText(params={}) {
    const evt = params['event']
    const container = evt && evt.target && evt.target.closest('.typable-container')
    if (!container) console.log('ERR: typeText !container', evt.target)

    const typableTextElement = this.typableTextElementWithinContainer(container)
    // const typableTextElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (!typableTextElement) return console.log('ERR: !typableTextElement', container)

    this.lcpHelper.stopTypingElement(typableTextElement)
    window.setTimeout(this.typeTextNow.bind(this, typableTextElement, params), 100)
  }

  async typeTextNow(el: Element, params={}) {
    this.lcpHelper.stopAllTyping = false 
    const block = params['block']
    // const container = elements && elements[0]
    // const typableTextElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (el.classList.contains('is-typed')) return
    el.classList.add('is-typed')
    el.closest('.typable-text-container').classList.add('is-typed')

    const cursorContainer = el.parentElement.querySelector('.typable-cursor-container') 
    cursorContainer.classList.remove('opacity-0')

    el.innerHTML = null

    const plainText = documentToPlainTextString(block.fields['body'])
    const typeParams = Object.assign({}, params, { shouldType: true, delay: 10, minDelay: 1 })

    // console.log('TODO: handleHoverService', plainText, el)
    this.lcpHelper.isTypingElements.push(el)
    await this.lcpHelper.typeSentence(plainText, el, typeParams)
    if (!this.lcpHelper.isTypingElements.includes(el)) return
    const link = this.lcpHelper.linkFromBlock(params['block'])
    if (link) {
      el.insertAdjacentHTML('beforeend', ` `)
      let a = document.createElement('a');
      // console.log('CHECK LINK', link)
      a.href = link.address // Insted of calling setAttribute 
      a.innerHTML = link.text
      el.appendChild(a)
      // el.insertAdjacentHTML('beforeend', `<a href=${link.address}>${link.text}</a>`)
      this.listenToLinkHover(el)

    }
    
    // typable-cursor-container
    if (params['removeCursorAfterTyping']) cursorContainer.classList.add('opacity-0')
  }

  listenToLinkHover(el: Element) {
    const link = el.querySelector('a')

    link.addEventListener('mouseenter', () => {
      // console.log('handleLinkHover', link)
      const container = this.getLinkContainer(link)
      const cursor = this.getContainerCursor(container)
      if (!cursor) return 
      cursor.classList.add('opacity-0')
      // Code to execute when the mouse enters the link area
      // link.style.backgroundColor = 'lightblue'; // Example: change background color
    })

    link.addEventListener('mouseleave', () => {
      // console.log('handleLinkBlur', link)
      const container = this.getLinkContainer(link)
      const cursor = this.getContainerCursor(container)
      if (!cursor) return 
      cursor.classList.remove('opacity-0')
      // Code to execute when the mouse leaves the link area
      // link.style.backgroundColor = 'initial'; // Example: revert background color
    })
  }

  getLinkContainer(link: Element): Element {
    const container = link.closest('.typable-text-outer')
    if (!container) { console.log('ERR: !container', link); return null }
    return container
  }

  getContainerCursor(container: Element): Element {
    const cursorElement = container.querySelector('.typable-cursor')
    if (!cursorElement) { console.log('ERR: !cursor', container); return null }
    return cursorElement
  }

}
